import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import * as Yup from 'yup';
import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';
import NewSurveySubRespondentContainer from './components/NewSurveySubRespondentContainer';
import NewSurveyForm from './NewSurveyForm';
import { searchSurveyTemp } from '../../../services/apps/SurveyTemplateService';
import { growlErrors } from '../../../utils/NotificationUtil';
import { growlShape, intlShape } from '../../../components/prop-types';
import { withGrowl } from '../../../components/GrowlNotifications';
import { withAccount } from '../../../components/AccountContext';
import Debug from '../../../components/Debug';
import { validationMessages } from '../../../i18n/common';

const buildValidationSchema = formatMessage => Yup.object().shape({
  surveyTemplate: Yup.object().required(formatMessage(validationMessages.required)),
  name: Yup.string().required(formatMessage(validationMessages.required)),
});

const i18n = defineMessages({
  cancel: {
    id: 'actions.cancel',
    defaultMessage: 'Cancel',
  },
  save: {
    id: 'actions.save',
    defaultMessage: 'Save',
  },
});

class NewSurveyFormContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingTemp: false,
      surveyTemplates: [],
    };

    this.handleSearchTemplate = this.handleSearchTemplate.bind(this);
  }

  componentDidMount() {
    this.fetchSurveyTemplate();
  }

  handleSearchTemplate(query) {
    this.fetchSurveyTemplate(query);
  }

  async fetchSurveyTemplate(query) {
    const { currentAccount, growl } = this.props;
    try {
      this.setState({ loadingTemp: true });
      const surveyTemplates = await searchSurveyTemp({
        aid: currentAccount,
        query,
      });
      this.setState({
        surveyTemplates,
        loadingTemp: false,
      });
    } catch (errors) {
      growlErrors(growl, errors);
      this.setState({ loadingTemp: false });
    }
  }

  render() {
    const {
      respondentGroups,
      respondent,
      onCancel,
      intl: { formatMessage },
    } = this.props;
    const { handleAddRespondent, handleRemoveRespondent, saveSurvey } = this.props;
    const {
      managers, peers, others, directReports,
    } = respondentGroups;
    const validationSchema = buildValidationSchema(formatMessage);
    const { surveyTemplates, loadingTemp } = this.state;

    const initialValues = {
      name: `${respondent.firstName} ${respondent.lastName}`,
      tags: [],
      commentsEnabled: false,
    };

    const saveText = formatMessage(i18n.save);
    const cancelText = formatMessage(i18n.cancel);

    return (
      <div className="p-grid">
        <div className="p-col-12">
          <div className="brand-detailed-wrapper">
            <Panel
              header={(
                <div className="p-grid p-nogutter">
                  <div className="p-col-12">
                    <span>{respondent.firstName}</span>
                    {' '}
                    <span>{respondent.lastName}</span>
                     -
                    <FormattedMessage id="360.new" defaultMessage="New Survey" />
                  </div>
                </div>
              )}
            >
              <Formik
                onSubmit={(values, formikBag) => {
                  const { resetForm } = formikBag;
                  saveSurvey(values);
                  resetForm();
                }}
                validationSchema={validationSchema}
                initialValues={initialValues}
                render={(formProps) => {
                  const { isSubmitting } = formProps;
                  return (
                    <Form>
                      <NewSurveyForm
                        formProps={formProps}
                        surveyTemplates={surveyTemplates}
                        processing={loadingTemp}
                        searchTemplate={this.handleSearchTemplate}
                      />
                      <NewSurveySubRespondentContainer
                        managers={managers}
                        peers={peers}
                        directReports={directReports}
                        others={others}
                        respondent={respondent}
                        handleAddRespondent={handleAddRespondent}
                        handleRemoveRespondent={handleRemoveRespondent}
                      />

                      <div>
                        <div>
                          <Button
                            type="submit"
                            disabled={isSubmitting}
                            icon={isSubmitting ? 'pi pi-spin pi-spinner' : ''}
                            label={saveText}
                          />
                          <Button type="button" className="p-button-secondary" onClick={onCancel} label={cancelText} />
                        </div>
                      </div>
                      <Debug />
                    </Form>
                  );
                }}
              />
            </Panel>
          </div>
        </div>
      </div>
    );
  }
}

NewSurveyFormContainer.propTypes = {
  respondentGroups: PropTypes.objectOf(PropTypes.any).isRequired,
  respondent: PropTypes.objectOf(PropTypes.any).isRequired,
  onCancel: PropTypes.func.isRequired,
  handleAddRespondent: PropTypes.func.isRequired,
  handleRemoveRespondent: PropTypes.func.isRequired,
  saveSurvey: PropTypes.func.isRequired,
  growl: growlShape.isRequired,
  currentAccount: PropTypes.string.isRequired,
  intl: intlShape.isRequired,
};

export default withAccount(withGrowl(injectIntl(NewSurveyFormContainer)));
